module.exports = __webpack_public_path__ + "img/baki-bg.8f6a7548.jpg";